import { render, staticRenderFns } from "./IkajoDeposit.vue?vue&type=template&id=7656c014&scoped=true"
import script from "./IkajoDeposit.vue?vue&type=script&lang=js"
export * from "./IkajoDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7656c014",
  null
  
)

export default component.exports